(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var AtlasCardWidget = /*#__PURE__*/function () {
    function AtlasCardWidget(params) {
      _classCallCheck(this, AtlasCardWidget);

      this.widget = params.widget;
      this.cards = this.widget.querySelectorAll('._a-card-block');
      this.length = this.cards.length;
      this.timerId = this.setThrottle();
      this.resized = true;
    }

    _createClass(AtlasCardWidget, [{
      key: "init",
      value: function init() {
        this.updateRadius();
        this.bindEvents();
      }
    }, {
      key: "columns",
      value: function columns() {
        var containerWidth = this.widget.clientWidth;
        var cardWidth = this.cards[0].clientWidth;
        return Math.round(containerWidth / cardWidth);
      }
    }, {
      key: "setRadius",
      value: function setRadius(card, radius) {
        card.style.borderRadius = "0px 0px ".concat(radius);
      }
    }, {
      key: "isDivisible",
      value: function isDivisible(num) {
        return Number.isInteger(num) ? true : false;
      }
    }, {
      key: "isEven",
      value: function isEven(num) {
        return num & 1 ? false : true;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        var _this = this;

        window.addEventListener("resize", function () {
          if (_this.resized) {
            clearTimeout(_this.timerId);
            _this.timerId = _this.setThrottle();

            _this.updateRadius();

            _this.resized = false;
          }
        });
      }
    }, {
      key: "setThrottle",
      value: function setThrottle() {
        var _this2 = this;

        return setTimeout(function () {
          _this2.resized = true;
        }, 500);
      }
    }, {
      key: "resetRadius",
      value: function resetRadius() {
        for (var i = 0; i < this.cards.length; i++) {
          var card = this.cards[i];
          card.style.borderRadius = '0px';
        }
      }
    }, {
      key: "updateRadius",
      value: function updateRadius() {
        var length = this.length,
            cards = this.cards;
        var col = this.columns();
        var rows = Math.floor(length / col);
        var offset = rows * col;
        var lonelyItems = length - offset;
        var divisible = this.isDivisible(length / col);
        this.resetRadius(); // Handle 1 edge case

        if (col === 1 || length === 1) {
          // console.log('only one');
          this.setRadius(cards[length - 1], '8px 8px');
          return;
        } // Handle 2 edge case


        if (length === 2 && col >= 2) {
          // console.log('only 2');
          this.setRadius(cards[length - 1], '8px 0px');
          this.setRadius(cards[length - 2], '0px 8px');
          return;
        }

        if (divisible) {
          // console.log('divisible');
          this.setRadius(cards[length - 1], '8px 0px');
          this.setRadius(cards[length - col], '0px 8px');
          return;
        }

        if (lonelyItems > 1) {
          // console.log('2 of me');
          this.setRadius(cards[length - 1], '8px 0px');
          this.setRadius(cards[length - 1 - 1], '0px 8px');
          this.setRadius(cards[length - 1 - col - 1], '0px 8px');
          return;
        } else {
          // console.log('1 of me');
          this.setRadius(cards[length - 1], '8px 8px');
          this.setRadius(cards[length - 1 - col], '0px 8px');
          return;
        }
      }
    }]);

    return AtlasCardWidget;
  }();

  window.addEventListener('load', function () {
    var widgets = document.getElementsByClassName('_a-card-cont');

    if (widgets.length > 0) {
      for (var i = 0; i < widgets.length; i++) {
        var widget = widgets[i];
        new AtlasCardWidget({
          widget: widget
        }).init();
      }
    }
  });
})();

},{}],2:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var Expander = /*#__PURE__*/function () {
    function Expander(params) {
      _classCallCheck(this, Expander);

      this.widget = params.widget;
      this.trigger = this.widget.querySelector('._a-expander-trigger');
      this.content = this.widget.querySelector('._a-expander-content');
      this.openedText = this.trigger.querySelector('.opened-text');
      this.closedText = this.trigger.querySelector('.closed-text');
      this.contentAnimation = null;
    }

    _createClass(Expander, [{
      key: "init",
      value: function init() {
        this.constructTimeline();
        this.addListeners();
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        var _this = this;

        this.trigger.addEventListener('click', function () {
          _this.toggleContent();
        });
      }
    }, {
      key: "toggleContent",
      value: function toggleContent() {
        this.contentAnimation.reversed() ? this.contentAnimation.play() : this.contentAnimation.reverse();
        this.trigger.classList.toggle('triggered');
      }
    }, {
      key: "constructTimeline",
      value: function constructTimeline() {
        var _this2 = this;

        var tl = gsap.timeline({
          paused: true,
          reversed: true
        });

        var setHeight = function setHeight() {
          return _this2.content.style.height = 'auto';
        };

        tl.from(this.content, {
          duration: 1,
          height: 0,
          onComplete: setHeight
        });
        tl.eventCallback("onComplete", setHeight);
        this.contentAnimation = tl;
      }
    }]);

    return Expander;
  }();

  window.addEventListener("DOMContentLoaded", function () {
    var widgets = document.querySelectorAll('._a-expander-container');
    if (widgets === null || widgets === undefined) return;
    widgets.forEach(function (widget) {
      new Expander({
        widget: widget
      }).init();
    });
  });
})();

},{}],3:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var PDFLoad = /*#__PURE__*/function () {
    function PDFLoad(params) {
      _classCallCheck(this, PDFLoad);

      this.container = params.container;
      this.iframe = this.container.getElementsByClassName('pdf_iframe')[0];
      this.minWidth = parseInt(params.minWidth);
      this.maxWidth = parseInt(params.maxWidth);
      this.maxHeight = parseInt(params.maxHeight);
      this.currentWidth = null;
      this.ratio = null;
      this.timeout = false;
      this.delay = 50;
    }

    _createClass(PDFLoad, [{
      key: "init",
      value: function init() {
        this.ratio = this.getRatio();
        this.currentWidth = this.getCurrentWidth();
        this.setHeight();
        this.loadInitial();
        this.addListeners();
        this.loadIframe();
      }
    }, {
      key: "loadIframe",
      value: function loadIframe() {
        var src = this.iframe.getAttribute('data-src');
        this.iframe.setAttribute('src', src);
      }
    }, {
      key: "loadInitial",
      value: function loadInitial() {
        var cur = this.getCurrentWidth();

        if (cur <= this.maxWidth || cur >= this.minWidth) {
          var padding = Math.ceil(cur * this.ratio);
          this.container.style.paddingTop = padding + 'px';
        }
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        var _this = this;

        window.addEventListener('resize', function () {
          _this.setHeight();
        });
      }
    }, {
      key: "getCurrentWidth",
      value: function getCurrentWidth() {
        return this.container.offsetWidth;
      }
    }, {
      key: "setHeight",
      value: function setHeight() {
        var cur = this.getCurrentWidth();

        if (cur >= this.maxWidth || cur <= this.minWidth) {
          return;
        }

        var padding = Math.ceil(cur * this.ratio);
        this.container.style.paddingTop = padding + 'px';
      }
    }, {
      key: "getRatio",
      value: function getRatio() {
        return this.maxHeight / this.maxWidth;
      }
    }]);

    return PDFLoad;
  }();

  document.addEventListener("DOMContentLoaded", function () {
    var pdfWidgets = document.getElementsByClassName('pdf_iframe_container');

    if (pdfWidgets !== undefined && pdfWidgets.length > 0) {
      for (var i = 0; i < pdfWidgets.length; i++) {
        var widget = pdfWidgets[i];
        var settings = JSON.parse(widget.getAttribute('data-settings'));
        var minWidth = settings.minWidth,
            maxWidth = settings.maxWidth,
            maxHeight = settings.maxHeight;
        new PDFLoad({
          container: widget,
          minWidth: minWidth,
          maxWidth: maxWidth,
          maxHeight: maxHeight
        }).init();
      }
    }
  });
})();

},{}],4:[function(require,module,exports){
"use strict";

require("../../extended-widgets/atlas-cards/assets/atlas-cards-script");

require("../../extended-widgets/atlas-pdf-display/assets/atlas-pdf-display-script");

require("../../extended-widgets/atlas-expander/assets/atlas-expander-script");

},{"../../extended-widgets/atlas-cards/assets/atlas-cards-script":1,"../../extended-widgets/atlas-expander/assets/atlas-expander-script":2,"../../extended-widgets/atlas-pdf-display/assets/atlas-pdf-display-script":3}]},{},[4]);
